import { jsx } from 'react/jsx-runtime';
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { makeStyles } from '@material-ui/core';

var NotFoundPage = function () {
    var _a, _b, _c;
    var history = useHistory();
    useEffect(function () {
        var _a, _b, _c, _d;
        if (!((_b = (_a = history === null || history === void 0 ? void 0 : history.location) === null || _a === void 0 ? void 0 : _a.pathname) === null || _b === void 0 ? void 0 : _b.includes('?'))) return;
        (_c = history === null || history === void 0 ? void 0 : history.replace) === null || _c === void 0 ? void 0 : _c.call(history, (_d = history === null || history === void 0 ? void 0 : history.location) === null || _d === void 0 ? void 0 : _d.pathname);
    }, [(_a = history === null || history === void 0 ? void 0 : history.location) === null || _a === void 0 ? void 0 : _a.pathname]);
    return ((_c = (_b = history === null || history === void 0 ? void 0 : history.location) === null || _b === void 0 ? void 0 : _b.pathname) === null || _c === void 0 ? void 0 : _c.includes('?')) ? null : jsx("div", { children: "Not found" });
};

var useStyles = makeStyles(function (theme) {
  return {};
});

export { NotFoundPage as N, useStyles as u };
